<tt-page *ngIf="!!edit">
    <tt-page-heading *ngIf="!!edit.page_heading" [ttModel]="edit.page_heading"></tt-page-heading>

    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ttLabel="position_id" [(ttModel)]="edit.position_id"></tt-input>
        <tt-input ttLabel="position_heading" [(ttModel)]="edit.position_heading"></tt-input>
        <tt-button-save ttText="position_save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
        <tt-button *ngIf="edit.position_keyno !== '0'" ttText="position_delete" (ttClick)="deleteValues()" ttIcon="fas fa-trash-alt" ttType="danger" [ttLoading]="deleting"></tt-button>
    </tt-card>
</tt-page>
